module.exports = __webpack_public_path__ + "img/img22.a026cfa9.svg";